import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
//import { initToolbar } from '@stagewise/toolbar';
import { environment } from '../environments/environment';
import { NavbarComponent } from './shared/navbar/navbar.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = 'ZingFleetUI';
  
  constructor() {
    // if (!environment.production) {
    //   initToolbar();
    // }
  }
}
